import { Injectable, inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import type { TaskInstanceExtended } from '@app/shared/interfaces';
import { TaskEditModalComponent } from './task-edit-modal.component';

export interface TaskEditModalData {
  taskUuid: string;
  initialMode?: 'overview' | 'access' | 'checklist-editor' | 'checklist-viewer';
}

export interface TaskEditModalResult {
  action: 'updated' | 'deleted';
  // For updated action, contains the updated task data
  task?: TaskInstanceExtended;
  // For deleted action, contains the UUID of the deleted task
  taskUuid?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TaskEditModalService {
  readonly #dialog = inject(MatDialog);
  #dialogRef: MatDialogRef<TaskEditModalComponent, TaskEditModalResult | null> | null = null;

  open(data: TaskEditModalData): MatDialogRef<TaskEditModalComponent, TaskEditModalResult | null> {
    this.#dialogRef = this.#dialog.open<TaskEditModalComponent, TaskEditModalData, TaskEditModalResult | null>(
      TaskEditModalComponent,
      {
        width: '100vw',
        height: '100vh',
        maxWidth: '100vw',
        maxHeight: '100vh',
        panelClass: ['task-edit-modal', '!m-0', '!rounded-none'],
        data,
        autoFocus: false,
        disableClose: true,
      }
    );

    return this.#dialogRef;
  }

  isOpen(): boolean {
    return !!this.#dialogRef;
  }
}
